import { IReview } from '~/assets/interfaces/reviews'
import { IProductReviewsBlock } from '~/assets/interfaces/product-page'

export interface IProductStructuredDataInput {
  name: string
  images: string[]
  description: string
  sku: string
  brand: string
  url: string
  currency: string
  price: number | null
  inStock: boolean
  reviews: IProductReviewsBlock | null
}

// Цена в разметке действительна месяц: дальше поисковик перепроверит.
export function priceValidUntil(from: Date = new Date()): Date {
  const date = new Date(from)
  date.setMonth(date.getMonth() + 1)
  return date
}

function reviewsStructuredData(items: IReview[]) {
  return items.map((item) => ({
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: item.rating,
      bestRating: '5',
    },
    author: {
      '@type': 'Person',
      name: item.name,
    },
    reviewBody: `${item.plus} ${item.minus} ${item.comment}`,
  }))
}

// JSON-LD schema.org/Product для <head> страницы товара.
export function productStructuredData(
  input: IProductStructuredDataInput
): Record<string, unknown> {
  const data: Record<string, unknown> = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: input.name,
    image: input.images,
    description: input.description,
    sku: input.sku,
    brand: {
      '@type': 'Brand',
      name: input.brand,
    },
    offers: {
      '@type': 'Offer',
      url: input.url,
      priceCurrency: input.currency,
      price: input.price,
      priceValidUntil: priceValidUntil().toISOString(),
      itemCondition: 'http://schema.org/NewCondition',
      availability: input.inStock
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
    },
  }

  const reviews = input.reviews
  if (reviews) {
    data.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: reviews.rating,
      reviewCount: reviews.amount,
    }
    if (reviews.items && reviews.items.length > 0) {
      data.review = reviewsStructuredData(reviews.items)
    }
  }

  return data
}
